import { render, staticRenderFns } from "./scientifique.vue?vue&type=template&id=73a682ab&scoped=true&"
import script from "./scientifique.vue?vue&type=script&lang=js&"
export * from "./scientifique.vue?vue&type=script&lang=js&"
import style0 from "./scientifique.vue?vue&type=style&index=0&id=73a682ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a682ab",
  null
  
)

export default component.exports